<template>
  <div class="title">
    <span>{{ text }}</span>
    <div v-if="hasMoreButton" @click="handleMore" class="more-text">更多 ></div>
  </div>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      required: true
    },
    hasMoreButton: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleMore() {
      this.$router.push({
        name: 'product'
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.title {
  display: inline-block;
  margin: 0 auto 40px auto;
  position: relative;
  @include text-36-bold;
  color: $main-color;
  line-height: 36px;
  font-size: 28px;

  &::after,
  &::before {
    content: '';
    position: absolute;
    top: 19px;
    width: 101px;
    height: 1px;
    background: rgba(41, 84, 208, 1);
  }

  &::after {
    left: -120px;
  }

  &::before {
    right: -120px;
  }
}
.more-text {
  position: absolute;
  cursor: pointer;
  @include text-16-400;
  line-height: 28px;
  right: -525px;
  top: 6px;
}
</style>
